import type { FieldValidationHandler } from '../components/types';
type ErrorMessageMaker = (value: string) => string;
const makeInvalidRegExpValidator = (regexp: string | RegExp, errorMessage?: string | ErrorMessageMaker): FieldValidationHandler<string> => {
  const REGEXP: RegExp = typeof regexp == 'string' ? new RegExp(regexp) : regexp;
  return value => {
    if (value && REGEXP.test(value)) {
      return {
        errors: [(typeof errorMessage == 'function' ? errorMessage?.(value) : errorMessage) ?? "Valor inválido"]
      };
    }
  };
};
export default makeInvalidRegExpValidator;